import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRight16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.0605 8.00003L9.38732 2.32684L8.32666 3.3875L12.1892 7.25L1 7.25V8.75L12.1892 8.75L8.32666 12.6126L9.38732 13.6732L15.0605 8.00003Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRight16.displayName = 'ArrowRight16';
export default ArrowRight16;
